import React from 'react';
import { ArrowRight, Building, TrendingUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import heroBg from '@/assets/hero-bg.jpg';

const Hero = () => {
  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="domov" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroBg}
          alt="ATREN INVEST - Real Estate Development"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-hero opacity-80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto animate-fade-in-up">
          {/* Main Heading */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Kakovost ni strošek,
            <span className="block text-atren-orange">
              je naložba.
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            Strokovno razvijamo, investiramo in gradimo nepremičnine. 
            Od ideje do ključa v roki - vaš zanesljiv partner za uspešne projekte.
          </p>

          {/* Stats Row */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-8 mb-12 text-white">
            <div className="flex items-center gap-3">
              <Building className="w-8 h-8 text-atren-orange" />
              <div className="text-left">
                <div className="text-2xl font-bold">50+</div>
                <div className="text-sm text-white/80">Projektov</div>
              </div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-white/30"></div>
            <div className="flex items-center gap-3">
              <TrendingUp className="w-8 h-8 text-atren-orange" />
              <div className="text-left">
                <div className="text-2xl font-bold">10+</div>
                <div className="text-sm text-white/80">Let izkušenj</div>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              size="lg"
              onClick={() => scrollToSection('#storitve')}
              className="bg-atren-orange hover:bg-atren-orange-dark text-white px-8 py-4 text-lg font-semibold shadow-primary hover:shadow-elegant transition-all duration-300 group"
            >
              Odkrijte naše storitve
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
            </Button>
            <Button
              size="lg"
              variant="hero-outline"
              onClick={() => scrollToSection('#projekti')}
              className="px-8 py-4 text-lg font-semibold transition-all duration-300"
            >
              Oglejte si projekte
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/50 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;